// Woo Checkout – "Verzend naar ander adres" toggle
let __wkShipMounted = false;

export function mount(root = document) {
  if (__wkShipMounted) __wkShipMounted = false; // laat re-mounts toe op nieuwe DOM
  const cb   = root.querySelector('#ship-to-different-address');
  const pane = root.querySelector('.wk-shipping-fields');
  if (!cb || !pane) return;

  const sync = () => pane.classList.toggle('is-open', !!cb.checked);
  sync();

  // voorkom dubbele binding
  if (cb.dataset.wkShipBound) return;
  cb.dataset.wkShipBound = '1';
  cb.addEventListener('change', sync);

  // re-sync bij Woo updates
  ['updated_checkout', 'wc_fragment_refresh'].forEach(evt =>
    document.body.addEventListener(evt, sync)
  );
}
